// baseVocabulary.js — labels stamped onto a base at create time

export const DEFAULT_BASE_LABEL = 'Base';
export const DEFAULT_BASE_LABEL_PLURAL = 'Bases';
export const DEFAULT_BASE_ICON_KEY = 'workspaces';

const BUILD_PRODUCT_LINE_KEY = 'build';

function normalizeString(value) {
  return String(value || '').trim();
}

/**
 * Vocabulary for chrome copy, copied from the pack at base create.
 * Legacy bases without stamps fall back to Base/Bases (Build → Project).
 *
 * @param {object|null} base
 * @returns {{ baseLabel: string, baseLabelPlural: string, iconKey: string }}
 */
export function getBaseVocabulary(base = null) {
  const stampedLabel = normalizeString(base?.baseLabel);
  const stampedPlural = normalizeString(base?.baseLabelPlural);
  const stampedIcon = normalizeString(base?.iconKey);
  const productLineKey = normalizeString(base?.productLineKey).toLowerCase();

  if (stampedLabel || stampedPlural) {
    return {
      baseLabel: stampedLabel || DEFAULT_BASE_LABEL,
      baseLabelPlural: stampedPlural || DEFAULT_BASE_LABEL_PLURAL,
      iconKey: stampedIcon || DEFAULT_BASE_ICON_KEY,
    };
  }

  if (productLineKey === BUILD_PRODUCT_LINE_KEY) {
    return {
      baseLabel: 'Project',
      baseLabelPlural: 'Projects',
      iconKey: stampedIcon || 'handyman',
    };
  }

  return {
    baseLabel: DEFAULT_BASE_LABEL,
    baseLabelPlural: DEFAULT_BASE_LABEL_PLURAL,
    iconKey: stampedIcon || DEFAULT_BASE_ICON_KEY,
  };
}
